// import axios from 'axios';



export interface IAccount {
  address: string
  address2:string
  bc_account_no: string
  blocked: boolean
  city: string
  club_code:string
  consent1: boolean
  consent1_date: string
  consent2: boolean
  consent2_date: string
  consent3: boolean
  consent3_date: string
  consent4: boolean
  consent4_date: string
  consent5: boolean
  consent5_date: string
  consent6: boolean
  consent6_date: string
  country: string
  create_date:string
  create_time: string
  date_blocked: string
  date_of_birth: string
  email_address: string
  first_name: string
  id: string
  id_card_no: string
  last_date_modified: string
  last_name: string
  last_time_modified: string
  line_user_id:string
  mobile_phone_no: string
  post_code:string
  ramianing_point: string
  scheme_code: string
  sex: string
  submitbut: boolean
  //AVCDAPNF.005  25/02/2025  Add Code for เพิ่ม field expires date และ expires point
  nearlyExpireDate: string
  nearlyExpirePoint: string
  //C-AVCDAPNF.005  25/02/2025  Add Code for เพิ่ม field expires date และ expires point
  communications: {
    email: boolean
    sms: boolean
    phone: boolean
  }
  gender: {
    Male: boolean
    Female: boolean
    NotSpecified: boolean
  }
  requireInfo: boolean
  birthyear:string
  birthmonth:string
  birthday:string
  scheme:string

}

export const defaultAccount: IAccount = {

  address: "",
  address2: "",
  bc_account_no: "",
  blocked: false,
  city: "",
  club_code: "",
  consent1: true,
  consent1_date: "",
  consent2: false,
  consent2_date: "",
  consent3: false,
  consent3_date: "",
  consent4: false,
  consent4_date: "",
  consent5: false,
  consent5_date: "",
  consent6: false,
  consent6_date: "",
  country: "",
  create_date:"",
  create_time: " ",
  date_blocked: "",
  date_of_birth: "",
  email_address: "",
  first_name: "",
  id: "",
  id_card_no: "",
  last_date_modified: "",
  last_name: "",
  last_time_modified: " ",
  line_user_id:"",
  mobile_phone_no: "",
  post_code: "",
  ramianing_point: "",
  scheme_code: "",
  sex: "",
  submitbut: true,
  //AVCDAPNF.005  25/02/2025  Add Code for เพิ่ม field expires date และ expires point
  nearlyExpireDate: '',
  nearlyExpirePoint: '',
  //C-AVCDAPNF.005  25/02/2025  Add Code for เพิ่ม field expires date และ expires point
  communications: {
    email: true,
    sms: false,
    phone: false,
  },
  gender: {
    Male: true,
    Female: false,
    NotSpecified: false,
  },
  requireInfo: false,
  birthyear:"",
  birthmonth:"",
  birthday:"",
  scheme:"",
}


export interface IAccountcustomer {
  email: string
  requireInfo: string
  timeZone: string
  username: string

}

export const defaultAccountcustomer: IAccountcustomer = {
  email: 'bangkoksync',
  requireInfo:'bangkoksync',
  timeZone: 'bangkoksync@loop.com',
  username:'0868138285',

}
